module.exports = __webpack_public_path__ + "ac95b9461cd95dd08e0c04e4dba59a9b.MP3";